export default __webpack_public_path__ + "static/discord-77d9421ebaa2f6efe28dcf76c0b60cbc.svg";